// 소셜 로그인 흐름(flowType) 선택 — 네이티브 앱만 PKCE, 웹 SPA는 implicit 유지 (2026-09-14)
// 조사 정본 docs/specs/2026-09-14-pkce-native-survey-astra.md §B-6
//  - 왜 네이티브만: implicit은 토큰이 커스텀 스킴 URL 해시(#access_token=…)에 실려 돌아와
//    같은 스킴을 등록한 다른 앱이 가로챌 수 있다. PKCE는 앱이 만든 code_verifier가 있어야
//    code를 세션으로 바꿀 수 있어, 가로챈 code만으로는 로그인이 안 된다.
//  - 왜 웹은 그대로: 같은 번들을 쓰는 웹 SPA 콜백(/auth/callback·/auth/spa-callback)은 implicit
//    fragment를 전제로 돌고 있고 이번 범위 밖이다.
//  - verifier 저장소는 supabase.ts의 capacitorStorage(Preferences) — 시스템 브라우저와 공유할 필요가
//    없다. 앱이 만들고(signInWithOAuth) 앱이 교환한다(deeplink.ts exchangeCodeForSession).
//  - 되돌리기: isNative 분기를 지우고 "implicit"으로. 세션 저장 키는 바꾸지 않는다.
//  - supabase.ts에서 분리한 이유: supabase.ts는 로드 시 createClient를 호출해 테스트에서 import할 수 없다.
//    (authFlow.ts는 로그인 화면의 별개 모듈 — 이름 충돌을 피해 authFlowType.ts)
export type AuthFlowType = "pkce" | "implicit";
export function resolveAuthFlowType(isNative: boolean): AuthFlowType {
  return isNative ? "pkce" : "implicit";
}
